module.exports = __webpack_public_path__ + "static/img/05no.98bcd96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/01home/05no.png
// module id = B3mR
// module chunks = 0